<template>
  <div class="redeemed-root mt-4">
    <div class="redeemed-title">Premios Canjeados</div>
    <hr />

    <table v-if="items.length > 0" class="w-100">
      <tbody v-for="(item, index) in items" :key="item.exchange_id">
        <tr>
          <td class="redeemed-product-col">
            <span class="font-weight-bold">{{ item.name }}</span>
            <br>
            <small class="text-muted redeemed-description">{{ item.description }}</small>
          </td>
          <td class="redeemed-date-col text-center redeemed-date-text">{{ item.date | date }}</td>
          <td class="redeemed-status-col text-center">
            <span :class="item.is_paid ? 'text-success' : 'text-warning'">
              {{ item.is_paid ? 'Entregado' : 'Pendiente' }}
            </span>
            <br>
            <small v-if="item.is_paid && item.delivered_date">{{ item.delivered_date }}</small>
          </td>
          <td class="redeemed-actions-col text-center">
            <a class="details-link" @click="openDetail(item)">Ver detalles</a>
          </td>
        </tr>
        <tr v-if="index < items.length - 1">
          <td colspan="4"><hr class="my-2"></td>
        </tr>
      </tbody>
    </table>

    <div v-else class="text-center w-100">
      AÚN NO TIENES PREMIOS CANJEADOS
    </div>

    <RedeemedAwardDetailModal ref="redeemedAwardDetailModal" />
  </div>
</template>

<script>
import RedeemedAwardDetailModal from './RedeemedAwardDetailModal.vue'

export default {
  name: 'RedeemedAwardsHistory',
  components: {
    RedeemedAwardDetailModal
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    openDetail (item) {
      this.$refs.redeemedAwardDetailModal.open(item)
    }
  }
}
</script>

<style scoped>
.redeemed-root {
  font-size: 12px;
}

.redeemed-title {
  font-size: 14px;
  font-weight: bold;
}

.redeemed-product-col {
  width: 45%;
}

.redeemed-date-col {
  width: 16%;
}

.redeemed-date-text {
  font-size: 11px;
}

.redeemed-status-col {
  width: 19%;
}

.redeemed-actions-col {
  width: 20%;
}

.redeemed-description {
  line-clamp: 2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.details-link {
  color: #39f;
  font-weight: bold;
  cursor: pointer;
}

.details-link:hover {
  text-decoration: underline;
}
</style>
